const FilterList = ({ children }) =>
    <ul className="cn-filterset">{children}</ul>;
export default FilterList;



// WEBPACK FOOTER //
// ./app/tickets/components/filter-list.jsx